import React from "react";
import ReactDom from "react-dom";
import App from "./pages/_app";
import './i18n';
import * as serviceWorker from "./serviceWorker";

ReactDom.render(
    <React.Suspense fallback={''}>
        <App />
    </React.Suspense>
    , document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
